module.exports = __webpack_public_path__ + "static/government-cyber-attacks@2x-98bf627f7d3926fcef79c748baadc4f9.jpg";